module.exports = __webpack_public_path__ + "media/src/images/icons/descending-21ab0425ef810f135861d97d841dcbf2.svg";